import { OnMessageCallback } from 'mqtt';
import { store } from '../../app/store';
import { aeroActions } from './aeroSlice';

export const adsbMqttParser: OnMessageCallback = (topic: any, payload: any, packet: any): void => {
    const msg = JSON.parse(payload.toString());
    const [, , , source, kind] = topic.split("/");

    if (kind === undefined) {
        if (msg.bbox) store.dispatch(aeroActions.add_adsb_bbox({bbox: msg.bbox, source}));
        msg.features.forEach((f: any) => {
            store.dispatch(aeroActions.add_adsb_feature({ feature: {...f, id: f.properties.icao24}, source, config: store.getState().mission.activeConfig}));
        });
    }
    else if (kind === "tx") {
        store.dispatch(aeroActions.adsb_tx({tx: msg.tx}));
    }
};